define('modules/static-data-fetcher/js/model/static-data-fetcher-model',['require','sdk!ivCore','ivUnderscore'],function(require) {
    "use strict";
    
    var iv = require('sdk!ivCore'),
        _ = require("ivUnderscore");
   
    var StaticDataFetcherModel = iv.Model.extend({
        parseJobLevels: function(jobLevelOptions) {
            return _.sortBy(jobLevelOptions, 'jobLevel');
        },
    	parseIndustryData : function(industryOptions) {
    		var self = this;
    		_.each(industryOptions, function(industryOption){
    			industryOption = self.formatKeys(industryOption, "code", "description");
    			industryOption.subIndustries = _.map(industryOption.subIndustries, function(subIndustry){
    				return self.formatKeys(subIndustry, "code", "description");
    			});
    		});
    		return industryOptions;
    	},
        parseTechData : function(techData) {
            var self = this;
            techData = _.map(techData, function(category){
                category = self.formatKeys(category, "categoryId", "categoryName");
                category.subCategories = _.map(category.subCategories, function(subCategory){
                    subCategory = self.formatKeys(subCategory, "subCategoryId", "subCategoryName");
                    subCategory.products = _.map(subCategory.products, function(product){
                        product = self.formatKeys(product, "productId", "productName");
                        return product;
                    });
                    return subCategory;
                });
                return category;
            });
            return techData;
        },
        parseTechDataWithOnlyProducts: function(techData){
            var withOnlyProducts = [];
            _.each(techData, function(category, i) {
    			_.each(category.subCategories, function(subCategory, j) {
    				_.each(subCategory.products, function(product, k) {
                        withOnlyProducts.push(product);
                    });
    			});
    		});
            return withOnlyProducts;
        },
    	formatKeys : function(obj, id, name) {
    		obj.id = obj[id];
    		obj.name = obj[name];

    		return obj;
    	},
        parseLocations : function(locations) {
            _.each(locations, function(region){
                region.id = region.name;
                region.children = region.countries.length || 0;
                _.each(region.countries, function(country) {
                    country.id = country.isoCode;
                    country.parent = region.id;
                    if (country.states) {
                        country.children = country.states.length || 0;
                        _.each(country.states, function(state) {
                            state.id = state.isoCode;
                            state.parent = country.isoCode;
                            state.grandParent = region.id;
                        });
                    }
                });
            });
            return locations;
        }
    });
    
    return StaticDataFetcherModel;
});
